import { useMemo }    from 'react';
import { Typography } from '@mui/material';

import { FormPart }             from '@modules/shared/components/FormPart';
import { getOptions }           from '@shared/commonFunctions';
import { Modal }                from '@shared/components/modals/Modal';
import { RadioButtonListField } from '@shared/fields/RadioButtonListField';
import { SaveButton }           from '@shared/inputs/Buttons';
import { FlexEnd }              from '@styles/StyledDiv';
import { ITrimsModalProps }     from '../interfaces';

export const TrimsModal = ({
  handleClose,
  handleSave,
  kbbTrims,
  nadaTrims,
  kbbFieldName = 'kbbTrim',
  nadaFieldName = 'nadaTrim',
  trimModalPosition
}: ITrimsModalProps) => {
  const formConfig = useMemo(
    () => [
      {
        children: 'KBB',
        variant: 'h2',
        component: Typography,
        width: '100%',
      },
      {
        name: kbbFieldName,
        label: '',
        options: getOptions(kbbTrims, 'key', 'key'),
        nextLine: true,
        component: RadioButtonListField,
        width: '100%',
      },
      {
        children: 'JD Power',
        variant: 'h2',
        component: Typography,
        width: '100%',
      },
      {
        name: nadaFieldName,
        label: '',
        options: getOptions(nadaTrims, 'key', 'key'),
        nextLine: true,
        component: RadioButtonListField,
        width: '100%',
      },
    ],
    [kbbTrims, nadaTrims, kbbFieldName, nadaFieldName]
  );

  return (
    <Modal
      open
      hideBackdrop
      title="Vehicle Features"
      dialogWidth="35vw"
      resetPosition={trimModalPosition}
      onClose={handleClose}
    >
      <>
        <FormPart config={formConfig} />

        <FlexEnd>
          <SaveButton
            type="button"
            label="Okay"
            onClick={handleSave ?? handleSave}
          />
        </FlexEnd>
      </>
    </Modal>
  );
};
